module.exports = __webpack_public_path__ + "media/images/drag-icon-34ac5eb2e185e090f458458fd990d312.svg";